import React from 'react'
import Myntra from "../assets/portfolio/mintra.png"
import Millap from "../assets/portfolio/millap.png"
import Loseit from "../assets/portfolio/loseit.png"
import Engagebay from "../assets/portfolio/engagebay.png"
import Geek from "../assets/portfolio/Geekbuying.png"
import {FaGithub} from "react-icons/fa"
import {SiNetlify} from "react-icons/si"
import {DiHtml5,DiCss3,DiFirebase,DiJavascript1,DiReact,DiNodejsSmall,DiMongodb} from "react-icons/di"
import {SiExpress,SiChakraui} from "react-icons/si"
const Project = () => {
    const projects=[
        {
            id:1,
            src:Loseit,
            name:"Loseit Clone",
            github:"https://github.com/supriyosamanta1997/Loseit",
            deploy:"https://isnt-supriyosamanta1997-gmail-com-awesome-216a0.netlify.app/",
            desc:"Lose it is a weight loss tracking website. Here user can track the time required to loss their targeted weight.",
            techStack:<DiHtml5 className='text-2xl'/>,
            techStack1:<DiCss3 className='text-2xl'/>,
            techStack2:<DiReact className='text-2xl'/>,
            techStack3:<DiFirebase className='text-3xl'/>,
            // techStack4:<DiJavascript1 className='text-2xl'/>
            style:"shadow-orange-400"
        },
        {
            id:2,
            src:Millap,
            name:"Millap Clone",
            github:"https://github.com/supriyosamanta1997/Millap_clone",
            deploy:"https://candid-ganache-399b55.netlify.app/",
            desc:"Milaap Free Crowdfunding for India Raise funds online for medical emergencies and social causes.",
            techStack:<DiHtml5 className='text-2xl'/>,
            techStack1:<DiCss3 className='text-2xl'/>,
            techStack2:<DiJavascript1 className='text-2xl'/>,
            style:"shadow-blue-500"
        },
        {
            id:3,
            src:Myntra,
            name:"Myntra Clone",
            github:"https://github.com/Priyanshu-Tyagi/Myntra_Clone",
            deploy:"https://scintillating-jelly-fdc7ef.netlify.app/",
            desc:"This is the UI clone of Myntra.com, which is a popular E-Commerce website.",
            techStack:<DiHtml5 className='text-2xl'/>,
            techStack1:<DiCss3 className='text-2xl'/>,
            techStack2:<DiJavascript1 className='text-2xl'/>,
            style:"shadow-red-600"
        },
        {
            id:4,
            src:Engagebay,
            name:"EngageBay Clone",
            github:"https://github.com/Sakil9051/brawny-base-7995/tree/main/engagebay-clone-328",
            deploy:"https://brawny-base-7995-6r5h.vercel.app/",
            desc:"Software is meant to solve problems. Complicated software only multiplies them. That is why we built EngageBay.",
            techStack:<DiHtml5 className='text-2xl'/>,
            techStack1:<DiCss3 className='text-2xl'/>,
            techStack2:<DiReact className='text-2xl'/>,
            techStack3:<DiFirebase className='text-3xl'/>,
            techStack4:<SiChakraui className='text-2xl'/>,
            style:"shadow-green-400"
        },
        {
         id:5,
         src:Geek,
         name:"Geekbuying Clone",
        github:"https://github.com/priyankadora20/punchy-substance-1301",
        deploy:"https://super-belekoy-306029.netlify.app/",
        desc:"GeekBuying is one of the leading E-commerce websites delivering a wide range of consumer technology across the globe.",
        techStack:<DiHtml5 className='text-2xl'/>,
        techStack1:<DiCss3 className='text-2xl'/>,
        techStack2:<DiReact className='text-2xl'/>,
        techStack3:<DiFirebase className='text-3xl'/>,
        techStack4:<SiChakraui className='text-2xl'/>,
        techStack5:<DiNodejsSmall className='text-2xl'/>,
        techStack6:<SiExpress className='text-2xl'/>,
        techStack7:<DiMongodb className='text-2xl'/>,
        style:"shadow-red-600" 
        },
    ]
  return (
    <div name="Projects" 
    className='bg-slate-800 w-full h-full text-slate-200 md:h-screen lg:h-auto pt-36'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div className=' pb-8 '>
                <p className=' text-4xl  font-bold inline border-b-4 border-amber-500'>Projects</p>
                <p className='text-2xl flex justify-center items-center font-bold text-amber-500 mt-20 '>Check Out Some of My Work Right Here</p>
            </div>

            <div className=' mt-4 grid sm:grid-cols-2 md:grid-cols-3 gap-8'>

                {
                    projects.map((project)=>{
                        return (
                            <div key={project.id} className={`shadow-lg ${project.style} rounded-lg hover:scale-110 duration-300`}>
                            <img src={project.src} alt=""
                            className='rounded-md'
                            />
                            <div>
                                <p className='text-xl text-amber-300 flex justify-center items-center box-border 
                                font-bold pt-6'>{project.name}</p>
                                {/* <p className='text-xl text-gray-500'>{project.description}</p> */}
                            </div>

                            <div  className=' mt-3 h-40 p-2 border-slate-200 box-border'>
                                {/* <h3>Project</h3> */}
                                <p className='font-bold text-amber-500'>{project.desc}</p><br/>
                                <span className='font-bold flex'>
                                <span className='text-slate-200'>TechStack: </span>
                                <span className='flex justify-around align-center w-full'>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack}</span>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack1}</span>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack2}</span>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack3}</span>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack4}</span>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack5}</span>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack6}</span>
                                <span className='text-amber-500 hover:scale-125 hover:text-fuchsia-400 duration-300'>{project.techStack7}</span>
                                </span>
                                </span>
                            </div>



                            
                            <div className='flex justify-center align-center'>
                            <button className='flex items-center justify-center w-1/2 px-4 py-2 m-6 duration-200 hover:scale-105 rounded-md 
                            bg-gradient-to-r from-cyan-500
                             to-blue-500 cursor-pointer'><span className='mr-2'><a href={project.deploy} target="_blank" rel="noreferrer"><SiNetlify/></a></span><a href={project.deploy} target="_blank" rel="noreferrer">Demo</a></button>
                            <button className='flex items-center justify-center  w-1/2 px-4 py-2 m-6 duration-200 hover:scale-105 rounded-md bg-gradient-to-r from-cyan-500
                             to-blue-500 cursor-pointer'><span className='mr-2'><a href={project.github} target="_blank" rel="noreferrer"><FaGithub/></a></span><a href={project.github} target="_blank" rel="noreferrer">Code</a></button>
                            </div>
                            </div>
                        )
                    })
                }
                
            </div>
        </div> 
    </div>
  )
}

export default Project